import { render, staticRenderFns } from "./main-printing.vue?vue&type=template&id=490af9fd&scoped=true&"
import script from "./main-printing.vue?vue&type=script&lang=js&"
export * from "./main-printing.vue?vue&type=script&lang=js&"
import style0 from "./main-printing.vue?vue&type=style&index=0&id=490af9fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490af9fd",
  null
  
)

export default component.exports